/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_LOCATIONS (state, locations) {
    state.locations = locations
  },
  REMOVE_RECORD (state, itemId) {
    const locationIndex = state.locations.findIndex((u) => u.LocationId === itemId)
    state.locations.splice(locationIndex, 1)
  }
}
